// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { ListTestIds } from '@trello/test-ids';

import { teacupWithHelpers } from 'app/scripts/views/internal/teacupWithHelpers';
const t = teacupWithHelpers('list');

// eslint-disable-next-line @trello/no-module-logic
export const ListTemplate = t.renderable(
  ({
    name,
    subscribed,
    loggedIn,
    editable,
    isTemplate,
    isCreateFromTemplateButtonHidden = false,
    isMenuButtonHidden = false,
  }: // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any) =>
    t.div('.list.js-list-content', function () {
      const headerClasses = {
        'list-header': true,
        'js-list-header': true,
        'u-clearfix': true,
      };

      t.div(
        { class: t.classify(headerClasses), 'data-testid': 'list-header' },
        function () {
          const inputClasses = {
            'list-header-name': true,
            'mod-list-name': true,
            'js-list-name-input': true,
          };

          t.div('.list-header-target.js-editing-target');

          t.h2(
            '.list-header-name-assist.js-list-name-assist',
            { dir: 'auto' },
            name,
          );

          t.textarea(
            {
              class: t.classify(inputClasses),
              'aria-label': name,
              spellcheck: 'false',
              dir: 'auto',
              maxLength: 512,
            },
            name,
          );

          t.div('.list-header-extras', function () {
            const subscribeClasses = {
              'list-header-extras-subscribe': true,
              'js-list-subscribed': true,
            };

            if (!subscribed) {
              // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
              subscribeClasses['hide'] = true;
            }

            t.span({ class: t.classify(subscribeClasses) }, () => {
              t.div('.icon-sm.icon-subscribe.mod-quiet');
            });

            t.span('.list-header-extras-limit-badge.js-list-limit-badge.hide');

            if (
              !isMenuButtonHidden &&
              ((loggedIn && !isTemplate) ||
                (loggedIn && isTemplate && editable))
            ) {
              return t.a(
                '.list-header-extras-menu.js-open-list-menu.icon-sm.icon-overflow-menu-horizontal',
                {
                  href: '#',
                  'aria-label': t.l('list-actions-ellipsis'),
                  'data-testid': ListTestIds.EditMenu,
                },
                () => t.div(),
              );
            }
          });

          return t.p('.list-header-num-cards.hide.js-num-cards');
        },
      );

      return t.div(
        '.card-composer-container.js-card-composer-container',
        function () {
          t.a(
            '.open-card-composer.js-open-card-composer',
            { href: '#', 'data-testid': ListTestIds.AddCardButton },
            function () {
              t.icon('add');
              t.span('.js-add-a-card', () => t.format('add-a-card'));
            },
          );
          if (!isCreateFromTemplateButtonHidden) {
            t.div('.js-card-templates-button.card-templates-button');
          }
          return t;
        },
      );
    }),
);
